var _rect, _polygon, _rect2, _rect3, _rect4, _polygon2, _rect5, _rect6, _polygon3, _rect7, _rect8, _polygon4, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _polygon5, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _polygon6, _rect28, _polygon7, _rect29, _rect30, _rect31, _rect32, _rect33, _polygon8, _rect34, _polygon9, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _polygon10, _rect42, _rect43, _rect44, _polygon11, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _polygon12, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _polygon13, _rect58, _rect59, _polygon14, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _path, _rect69, _polygon15, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _polygon16, _rect84, _rect85, _rect86, _rect87, _rect88, _polygon17, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _polygon18, _rect108, _polygon19, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _polygon20, _polygon21, _polygon22, _rect115, _polygon23, _rect116, _rect117, _rect118, _polygon24, _rect119, _polygon25, _rect120, _rect121, _rect122, _rect123, _polygon26, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB2Inline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 990 720"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 157,
    width: 21,
    height: 43,
    "data-id": "A221,222"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "78.2 157 99 157 99 200 78 200 78 157 78.2 157",
    "data-id": "A223,224"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 200.96,
    width: 21,
    height: 44.04,
    "data-id": "A221,222"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 200.96,
    width: 21,
    height: 44.04,
    "data-id": "A223,224"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 157,
    width: 21,
    height: 42.92,
    "data-id": "A225,226"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "150.94 157 172 157 172 199.92 151 199.92 150.94 157",
    "data-id": "A227,228"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 173.1,
    y: 157,
    width: 20.9,
    height: 42.92,
    "data-id": "A229,230"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 201.02,
    width: 21,
    height: 43.98,
    "data-id": "A225,226"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "150.94 201.02 172 201.02 172 245 151 245 150.94 201.02",
    "data-id": "A227,228"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 173.1,
    y: 201.02,
    width: 20.9,
    height: 43.98,
    "data-id": "A229,230"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 205.97,
    y: 201.02,
    width: 22.03,
    height: 43.98,
    "data-id": "A231,232"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "205.97 199.92 205.97 157 228 157 228 200.19 205.97 200.19 205.97 199.92",
    "data-id": "A231,232"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 239.06,
    y: 157,
    width: 20.94,
    height: 43,
    "data-id": "A233,234"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 261.72,
    y: 157,
    width: 21.28,
    height: 43,
    "data-id": "A235,356"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 239.06,
    y: 201.02,
    width: 20.94,
    height: 43.98,
    "data-id": "A233,234"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 260.9,
    y: 201.02,
    width: 22.1,
    height: 43.98,
    "data-id": "A235,356"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 174,
    width: 21,
    height: 44.07,
    "data-id": "A302,303"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 174,
    width: 21,
    height: 44.07,
    "data-id": "A304,305"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 218.8,
    width: 21,
    height: 42.2,
    "data-id": "A302,303"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 218.8,
    width: 21,
    height: 42.2,
    "data-id": "A304,305"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 217,
    width: 21.12,
    height: 44,
    "data-id": "A306,307"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 173,
    width: 21.12,
    height: 43.07,
    "data-id": "A306,307"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 374.36,
    y: 218.8,
    width: 20.64,
    height: 42.2,
    "data-id": "A308"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 219,
    width: 21,
    height: 42,
    "data-id": "A309"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "418.05 219 438 219 438 261 418 261 418.05 219",
    "data-id": "A310"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 217,
    width: 21,
    height: 43,
    "data-id": "A311"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 493.32,
    y: 217,
    width: 21.68,
    height: 43,
    "data-id": "A312"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 522,
    y: 217,
    width: 21,
    height: 43,
    "data-id": "A313"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 544.1,
    y: 217,
    width: 20.9,
    height: 43,
    "data-id": "A314"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 291,
    width: 21,
    height: 44,
    "data-id": "A219,220"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 69.97,
    y: 291,
    width: 22.03,
    height: 44,
    "data-id": "A217,218"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 336.04,
    width: 21,
    height: 42.96,
    "data-id": "A219,220"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "69.97 336.04 92 336.04 92 379 70 379 69.97 336.04",
    "data-id": "A217,218"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 380.02,
    width: 21,
    height: 43.67,
    "data-id": "A203,204"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "69.97 380.02 92 380.02 92 423.69 70 423.69 69.97 380.02",
    "data-id": "A205,206"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 424.98,
    width: 21,
    height: 43.02,
    "data-id": "A203,204"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 69.97,
    y: 424.98,
    width: 22.03,
    height: 43.02,
    "data-id": "A205,206"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 421,
    width: 21,
    height: 43,
    "data-id": "A207"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 155.95,
    y: 421,
    width: 22.05,
    height: 43,
    "data-id": "A208"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 437,
    width: 44,
    height: 21.03,
    "data-id": "A209"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "192 435.09 192 414 236 414 236 436 192 436 192 435.09",
    "data-id": "A210"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 384,
    width: 44,
    height: 22.03,
    "data-id": "A211"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "193 383.06 193 362 237 362 237 383 193 383.06",
    "data-id": "A212"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 333,
    width: 44,
    height: 21.13,
    "data-id": "A213"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 311.04,
    width: 44,
    height: 21.07,
    "data-id": "A214"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 291,
    width: 28,
    height: 43,
    "data-id": "A216"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 163.05,
    y: 291,
    width: 20.95,
    height: 44,
    "data-id": "A215"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 320,
    width: 43,
    height: 21,
    "data-id": "A237,238"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 329.11,
    y: 320,
    width: 43.89,
    height: 21,
    "data-id": "A237,238"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 341.97,
    width: 43,
    height: 21,
    "data-id": "A239,240"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "329.11 341.97 373 341.97 373 362.97 328.94 362.97 328.94 341.97 329.11 341.97",
    "data-id": "A239,240"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 375,
    width: 43,
    height: 21,
    "data-id": "A241,242"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 396.98,
    width: 43,
    height: 21.16,
    "data-id": "A243,244"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 329.05,
    y: 396.98,
    width: 43.95,
    height: 21.16,
    "data-id": "A243,244"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "328.94 375 373 375 373 396 329.05 396 328.94 375",
    "data-id": "A241,242"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 428.91,
    width: 43,
    height: 21.09,
    "data-id": "A245,246"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 329.05,
    y: 428.91,
    width: 43.95,
    height: 21.09,
    "data-id": "A245,246"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 459,
    width: 21,
    height: 44,
    "data-id": "A247"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 312.12,
    y: 459,
    width: 21.88,
    height: 44,
    "data-id": "A248"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 341.99,
    y: 459,
    width: 31.01,
    height: 43,
    "data-id": "A249"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 559,
    width: 21,
    height: 44,
    "data-id": "A201,202"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "46 557.75 46 515 67 515 67 558 46 558 46 557.75",
    "data-id": "A201,202"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 76.81,
    y: 515,
    width: 21.19,
    height: 43,
    "data-id": "A199,200"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 76.81,
    y: 559,
    width: 21.19,
    height: 44,
    "data-id": "A199,200"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 99.07,
    y: 515,
    width: 20.93,
    height: 43,
    "data-id": "A197,198"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 99.07,
    y: 559,
    width: 20.93,
    height: 44,
    "data-id": "A197,198"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 133.05,
    y: 515,
    width: 20.95,
    height: 43,
    "data-id": "A195,196"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 133.05,
    y: 559,
    width: 20.95,
    height: 44,
    "data-id": "A195,196"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 155.11,
    y: 515,
    width: 21.89,
    height: 43,
    "data-id": "A193,194"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "155.11 559 177 559 177 603 155.11 603 155.11 559",
    "data-id": "A193,194"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 188.14,
    y: 559,
    width: 21.86,
    height: 44,
    "data-id": "A191,192"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 188.14,
    y: 515,
    width: 21.86,
    height: 43,
    "data-id": "A191,192"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "211.01 515 232 515 232 558 211 558 211.01 515",
    "data-id": "A189,190"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 559,
    width: 21,
    height: 44,
    "data-id": "A189,190"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 238.8,
    y: 558,
    width: 21.34,
    height: 43,
    "data-id": "A188"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 260.94,
    y: 558,
    width: 22.14,
    height: 43,
    "data-id": "A187"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 289.9,
    y: 558,
    width: 21.1,
    height: 43,
    "data-id": "A186"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 558,
    width: 22,
    height: 43,
    "data-id": "A185"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 344.95,
    y: 558,
    width: 31.05,
    height: 43,
    "data-id": "A184"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 387.89,
    y: 558,
    width: 21.11,
    height: 43,
    "data-id": "A183"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 410.54,
    y: 558,
    width: 21.46,
    height: 43,
    "data-id": "A182"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 433,
    y: 558,
    width: 21,
    height: 43,
    "data-id": "A181"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M461.96,558h21.04v43h-21l-.04-43Z",
    "data-id": "A180"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 484.91,
    y: 558,
    width: 21.09,
    height: 43,
    "data-id": "A179"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "506.86 558 528 558 528 601 507 601 506.86 558",
    "data-id": "A178"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 536.85,
    y: 558,
    width: 22.15,
    height: 43,
    "data-id": "A177"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 571.06,
    y: 558,
    width: 20.94,
    height: 43,
    "data-id": "A176"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 592.87,
    y: 558,
    width: 21.13,
    height: 43,
    "data-id": "A175"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 624,
    y: 559,
    width: 20.84,
    height: 40,
    "data-id": "A174"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 646.98,
    y: 559,
    width: 19.02,
    height: 40,
    "data-id": "A173"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 674,
    y: 548,
    width: 31,
    height: 43,
    "data-id": "A172"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 712,
    y: 559,
    width: 21,
    height: 40,
    "data-id": "A171"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 735.12,
    y: 559,
    width: 20.88,
    height: 40,
    "data-id": "A170"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 758.02,
    y: 559,
    width: 20.98,
    height: 40,
    "data-id": "A169"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 809,
    y: 546,
    width: 22,
    height: 43,
    "data-id": "A168"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 832.08,
    y: 546,
    width: 20.92,
    height: 43,
    "data-id": "A167"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 861,
    y: 559,
    width: 21,
    height: 40,
    "data-id": "A166"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 882.9,
    y: 559,
    width: 21.1,
    height: 40,
    "data-id": "A165"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 912,
    y: 545,
    width: 22,
    height: 44.09,
    "data-id": "A164"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "935.04 545 956 545 956 589.09 935.04 589.09 935.04 544.34",
    "data-id": "A163"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 382,
    y: 312,
    width: 21,
    height: 44,
    "data-id": "A300,301"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 404,
    y: 312,
    width: 21,
    height: 44,
    "data-id": "A298,299"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 382,
    y: 356.9,
    width: 21,
    height: 43.09,
    "data-id": "A300,301"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 404,
    y: 356.9,
    width: 21,
    height: 43.09,
    "data-id": "A298,299"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 419,
    width: 21,
    height: 44,
    "data-id": "A250,251"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "412.19 419 433.1 419 433.1 463 411.92 463 411.92 419 412.19 419",
    "data-id": "A252,253"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 463.91,
    width: 21,
    height: 43.09,
    "data-id": "A250,251"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 411.92,
    y: 463.91,
    width: 21.18,
    height: 43.09,
    "data-id": "A252,253"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 462,
    y: 464,
    width: 22,
    height: 44,
    "data-id": "A254"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 485.07,
    y: 464,
    width: 20.93,
    height: 44,
    "data-id": "A255"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 507,
    y: 464,
    width: 21,
    height: 44,
    "data-id": "A256"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 535.77,
    y: 464,
    width: 21.23,
    height: 43.03,
    "data-id": "A257"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 483,
    y: 430,
    width: 43,
    height: 21,
    "data-id": "A291,290"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 527.02,
    y: 430,
    width: 43.98,
    height: 21,
    "data-id": "A291,290"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 527.02,
    y: 391,
    width: 43.98,
    height: 20.95,
    "data-id": "A292"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 527.02,
    y: 369,
    width: 43.98,
    height: 21.05,
    "data-id": "A293"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 527.02,
    y: 340,
    width: 43.98,
    height: 20.91,
    "data-id": "A294"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 527.02,
    y: 317.94,
    width: 43.98,
    height: 21.22,
    "data-id": "A295"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 492,
    y: 308,
    width: 21,
    height: 43,
    "data-id": "A296"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 308,
    width: 21,
    height: 43,
    "data-id": "A297"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 624,
    y: 445,
    width: 21,
    height: 38,
    "data-id": "A258"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 646.05,
    y: 445,
    width: 19.95,
    height: 38,
    "data-id": "A259"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 618,
    y: 419,
    width: 43,
    height: 22,
    "data-id": "A288"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 662,
    y: 419,
    width: 44,
    height: 22,
    "data-id": "A289"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 674,
    y: 448,
    width: 22,
    height: 43,
    "data-id": "A260"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "618 412.01 618 391 662 391 662 412 618 412.01",
    "data-id": "A286"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 662.82,
    y: 391,
    width: 43.18,
    height: 21.01,
    "data-id": "A287"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "618 368.83 662 368.83 662 389.92 617.61 389.92 618 368.83",
    "data-id": "A284"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 662.82,
    y: 368.83,
    width: 43.18,
    height: 21.08,
    "data-id": "A285"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 618,
    y: 340,
    width: 44,
    height: 21,
    "data-id": "A283"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 618,
    y: 318,
    width: 44,
    height: 21.04,
    "data-id": "A282"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 669,
    y: 317,
    width: 21,
    height: 43,
    "data-id": "A281"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 691,
    y: 317,
    width: 21,
    height: 43,
    "data-id": "A280"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 727.92,
    y: 317,
    width: 21.08,
    height: 43,
    "data-id": "A279"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "750.06 317 771 317 771 360 750 360 750.06 317",
    "data-id": "A278"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "624 217 645 217 645 261 623 261 623 217 624 217",
    "data-id": "A315"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "645.81 217 667 217 667 261 646 261 645.81 217",
    "data-id": "A316"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 674.98,
    y: 217,
    width: 21.02,
    height: 44,
    "data-id": "A317"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "696.93 217 718 217 718 261 697 261 696.93 217",
    "data-id": "A318"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 726.97,
    y: 217,
    width: 21.03,
    height: 43,
    "data-id": "A319"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 748.84,
    y: 217,
    width: 21.16,
    height: 43,
    "data-id": "A320"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 770.95,
    y: 217,
    width: 21.05,
    height: 43,
    "data-id": "A321"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "801.09 217 822 217 822 260 801 260 801.09 217",
    "data-id": "A322"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 822.98,
    y: 217,
    width: 22.02,
    height: 43,
    "data-id": "A323"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "846.01 217 867 217 867 260 846 260 846.01 217",
    "data-id": "A324"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 874,
    y: 220,
    width: 31,
    height: 43.23,
    "data-id": "A325"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 912.06,
    y: 220,
    width: 20.94,
    height: 43.23,
    "data-id": "A326"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 934.78,
    y: 220,
    width: 21.22,
    height: 43.23,
    "data-id": "A327"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 801,
    y: 314,
    width: 21,
    height: 43,
    "data-id": "A276"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "823.16 314 844 314 844 357 822.98 357 822.98 314 823.16 314",
    "data-id": "A274"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 845.04,
    y: 314,
    width: 21.96,
    height: 43,
    "data-id": "A273"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 801,
    y: 358.02,
    width: 21,
    height: 44.03,
    "data-id": "A277"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 822.98,
    y: 358.02,
    width: 21.02,
    height: 44.03,
    "data-id": "A275"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 874.77,
    y: 314,
    width: 22.23,
    height: 43,
    "data-id": "A272"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 874.77,
    y: 358.02,
    width: 22.23,
    height: 44.03,
    "data-id": "A271"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 913,
    y: 324,
    width: 22,
    height: 44,
    "data-id": "A137"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 935.94,
    y: 324,
    width: 21.06,
    height: 43.5,
    "data-id": "A102"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 720.6,
    y: 448,
    width: 21.4,
    height: 44,
    "data-id": "A261"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 743.08,
    y: 448,
    width: 20.92,
    height: 44,
    "data-id": "A262"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 810,
    y: 403,
    width: 21,
    height: 43.93,
    "data-id": "A264"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 832.05,
    y: 403,
    width: 20.83,
    height: 43.93,
    "data-id": "A266"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 859.99,
    y: 403,
    width: 21.01,
    height: 43.93,
    "data-id": "A268"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 882.73,
    y: 403,
    width: 21.27,
    height: 43.93,
    "data-id": "A270"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 810,
    y: 448,
    width: 21,
    height: 43.26,
    "data-id": "A263"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 832.05,
    y: 448,
    width: 20.95,
    height: 43,
    "data-id": "A265"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 859.99,
    y: 448,
    width: 21.01,
    height: 43,
    "data-id": "A267"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 882.73,
    y: 448,
    width: 21.27,
    height: 43,
    "data-id": "A269"
  })));
}
export default __webpack_public_path__ + "static/b-2.inline.b6251fcf.svg";
export { SvgB2Inline as ReactComponent };